import _createForOfIteratorHelper from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
import * as echarts from 'echarts';

require('echarts/theme/macarons'); // echarts theme


import { debounce } from '@/utils';
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    data: {
      type: Array,
      default: null
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '60vh'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    xAxisData: {
      type: Array,
      required: true
    },
    yAxisDatas: {
      type: Object,
      required: true
    },
    metrics: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    stack: {
      type: String,
      default: null
    },
    percent: {
      type: Boolean,
      default: false
    },
    tooltipFormatter: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  watch: {
    yAxisDatas: {
      deep: true,
      handler: function handler() {
        this.setOptions();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();

    if (this.autoResize) {
      this.__resizeHanlder = debounce(function () {
        if (_this.chart) {
          _this.chart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.__resizeHanlder);
    } // 监听侧边栏的变化


    var sidebarElm = document.getElementsByClassName('el-aside')[0];
    sidebarElm.addEventListener('transitionend', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHanlder);
    }

    var sidebarElm = document.getElementsByClassName('el-aside')[0];
    sidebarElm.removeEventListener('transitionend', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions: function setOptions() {
      var showLegend = true;

      if (this.metrics.length >= 15) {
        showLegend = false;
      }

      var selectA = {};

      for (var i in this.metrics) {
        selectA[this.metrics[i]] = parseInt(i) === this.metrics.length - 1; // console.log('this.metrics', i, this.metrics.length - 1, sa, parseInt(i) === this.metrics.length - 1, selectA[sa])
      }

      var option = {
        title: {
          text: this.title,
          textStyle: {
            fontWeight: 'normal',
            fontSize: 16,
            color: '#5695f3'
          },
          left: 'left'
        },
        label: {
          show: true,
          position: 'top'
        },
        xAxis: {
          data: this.xAxisData,
          boundaryGap: false,
          axisTick: {
            show: false
          }
        },
        grid: {
          left: 20,
          right: 80,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10],
          backgroundColor: 'rgba(80, 80, 80, 0.8)'
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        legend: {
          show: showLegend,
          selected: selectA,
          data: this.metrics
        },
        series: []
      };

      if (this.percent) {
        option.yAxis.axisLabel = {
          show: true,
          interval: 'auto',
          formatter: function formatter(value, index) {
            return value + '%'; // value.toString().substr(0, 3) + '%'
          }
        };
      }

      if (this.tooltipFormatter) {
        option.tooltip.formatter = this.tooltipFormatter;
      }

      var _iterator = _createForOfIteratorHelper(this.metrics),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var metric = _step.value;
          var series = {
            name: metric,
            stack: this.stack,
            smooth: true,
            type: 'line',
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: true,
            lineStyle: {
              width: 1
            },
            selectedMode: false,
            data: this.yAxisDatas[metric],
            animationDuration: 1000,
            animationEasing: 'cubicInOut'
          };

          if (this.stack) {
            series['areaStyle'] = {};
          } else if (!this.percent) {
            series['itemStyle'] = {
              borderWidth: 12,
              label: {
                show: true
              }
            };
          } // console.log('series', option, series)


          option.series.push(series);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.chart.setOption(option, true);
    },
    initChart: function initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions();
    }
  }
};